window.$ = window.jQuery = require('jquery');

require('popper.js/dist/popper.min');
window.bootstrap = require('bootstrap/dist/js/bootstrap.min');

window.VGNav = require('vgnav/dist/js/vgnav.min').default;
window.AOS = require('aos/dist/aos');
window.fancybox = require('@fancyapps/ui/dist/fancybox.esm');

require('vgformsender/dist/js/vgformsender.min');
require('vgscrollto/assets/js/jquery.vegasScrollTo');
require('vgsidebar/dist/js/vgsidebar');
require('inputmask/dist/inputmask');
require('jquery-nice-select/js/jquery.nice-select');

require('../../vendor/modules/bg');
require('../../vendor/modules/carousel');
require('../../vendor/modules/modal');
require('../../vendor/modules/mask');

require('./modules/vegas');
require('./modules/constructor');
require('./modules/order');
require('./modules/ym');
require('./functions');

require('./modules/auth');
// [[vegas]]
require('./custom');
